import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
// import const_sampler from 'jaeger-client/dist/src/samplers/const_sampler';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import Left from '../layout/left';
import Right from '../layout/right';

/**
 * for this page
 */
let realW = 0;
let realH = 0;
let setpage = new Image();
const toggle_open_text = '<img src="//p0.ifengimg.com/fe/fh_index/images/zk_56dab43e.png" alt=""/>';
const toggle_close_text = '<img src="//p0.ifengimg.com/fe/fh_index/images/closed_88a882d3.png" alt=""/>';
const Layout = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };
        state = {
            bef: true,
            toggle: true,
            toggleOpen: false,
            click: true,
            left: false,
            box1pClass: false,
            ball1Class: false,
            box2pClass: false,
            ball2Class: false,
            box3pClass: false,
            ball3Class: false,
            box4pClass: false,
            ball4Class: false,
        };
        componentDidMount() {
            realW = window.innerWidth;
            realH = window.innerHeight;
            // this.init();
            this.findDimensions();
            window.addEventListener('load', this.handleLoad);
            window.addEventListener('resize', this.findDimensions);
        }
        componentWillUnmount() {
            window.removeEventListener('resize', this.findDimensions);
            window.removeEventListener('load', this.handleLoad);
        }
        // 彩色层蒙版最后状态
        color_c = () => {
            // getclass('.chib1 div')[1].style.webkitMaskPosition = '0px 0px';
            // getclass('.chib2 div')[1].style.webkitMaskPosition = '0px 0px';
            this.refs.chib12.style.webkitMaskPosition = '0px 0px';
            this.refs.chib22.style.webkitMaskPosition = '0px 0px';

            console.log('color_c');
        };
        color_b = () => {
            // this.refs.chib12.style.webkitMaskPosition = `${-realW * 0.34 * 0.91}px 0px`;
            // this.refs.chib12.style.transition = 'all 5s';
            // this.refs.chib22.style.webkitMaskPosition = `${realW * 0.34 * 0.91}px 0px`;
            // this.refs.chib22.style.transition = 'all 5s';
            this.refs.chib12.style.opacity = 1;
            this.refs.chib22.style.opacity = 1;
        };

        test = () => {
            if (window.ActiveXObject || 'ActiveXObject' in window) {
                this.refs.box1p.style.opacity = '0';
                this.refs.box1a.styles.opacity = '0';
                this.refs.box2p.style.opacity = '0';
                this.refs.box2a.style.opacity = '0';
                this.refs.box3a.style.opacity = '0';
                this.refs.box3p.style.opacity = '0';
                this.refs.box4p.style.opacity = '0';
                this.refs.box4a.style.opacity = '0';
                // setTimeout("all()",1000);
                // setTimeout("hqmo()",1800);
                setTimeout(() => this.all(), 1000);
                setTimeout(() => this.hqmo(), 1800);
            } else {
                // document.onmousemove = this.mouseMove();
                setTimeout(() => {
                    document.onmousemove = this.mouseMove;
                }, realW * 5);
                this.refs.box1p.style.transition = 'all 4s';
                this.refs.box1p.className = '';
                this.refs.box2p.style.transition = 'all 4s';
                this.refs.box2p.className = '';
                this.refs.box3p.style.transition = 'all 4s';
                this.refs.box3p.className = '';
                this.refs.box4p.style.transition = 'all 4s';
                this.refs.box4p.className = '';
            }
        };
        all = () => {
            this.refs.box1a.style.transition = 'all 2s';
            this.refs.box2a.style.transition = 'all 2s';
            this.refs.box3a.style.transition = 'all 2s';
            this.refs.box4a.style.transition = 'all 2s';
        };
        hqmo = () => {
            document.onmousemove = this.mouseMove;
            this.refs.box1p.style.transition = 'all 1.5s';
            this.refs.box1a.styles.opacity = '1';
            this.refs.box2p.style.transition = 'all 1.5s';
            this.refs.box2a.styles.opacity = '1';
            this.refs.box3p.style.transition = 'all 1.5s';
            this.refs.box3a.styles.opacity = '1';
            this.refs.box4p.style.transition = 'all 1.5s';
            this.refs.box4a.styles.opacity = '1';
        };
        mouseMove = ev => {
            ev = ev || window.event;
            // ev = window.event;
            const mousePos = this.mousePosition(ev);

            this.refs.box1p.style.webkitMaskSize = '0px';
            this.refs.box1p.className = '';
            this.refs.box2p.style.webkitMaskSize = '0px';
            this.refs.box2p.className = '';
            this.refs.box3p.style.webkitMaskSize = '0px';
            this.refs.box3p.className = '';
            this.refs.box4p.style.webkitMaskSize = '0px';
            this.refs.box4p.className = '';

            if (mousePos.x <= realW * 0.45 && mousePos.y <= realH * 0.4) {
                // console.log('1');
                this.refs.box1p.style.webkitMaskSize = '2200px';
                this.setState({
                    box1pClass: true,
                    box2pClass: false,
                    box3pClass: false,
                    box4pClass: false,
                    ball1Class: true,
                });
                // this.refs.box1p.className = 'tj_filter';
                // this.refs.ball1.classList.add('amt');
            } else if (mousePos.x <= realW * 0.45 && mousePos.y >= realH * 0.5) {
                // console.log('2');
                this.refs.box2p.style.webkitMaskSize = '2200px';
                // this.refs.box2p.className = 'tj_filter';
                // this.refs.ball2.classList.add('amt');
                this.setState({
                    box1pClass: false,
                    box2pClass: true,
                    box3pClass: false,
                    box4pClass: false,
                    ball2Class: true,
                });
            } else if (mousePos.x >= realW * 0.55 && mousePos.y <= realH * 0.5) {
                // console.log('3');
                this.refs.box3p.style.webkitMaskSize = '2200px';
                // this.refs.box3p.className = 'tj_filter';
                // this.refs.ball3.classList.add('amt');
                this.setState({
                    box1pClass: false,
                    box2pClass: false,
                    box3pClass: true,
                    box4pClass: false,
                    ball3Class: true,
                });
            } else if (mousePos.x >= realW * 0.55 && mousePos.y >= realH * 0.4) {
                // console.log('4');
                this.refs.box4p.style.webkitMaskSize = '2200px';
                // this.refs.box4p.className = 'tj_filter';
                // this.refs.ball4.classList.add('amt');
                this.setState({
                    box1pClass: false,
                    box2pClass: false,
                    box3pClass: false,
                    box4pClass: true,
                    ball4Class: true,
                });
            }
        };
        mousePosition = ev => {
            // console.log('ev==', ev);
            // if (ev) {

            // }
            if (ev.pageX || ev.pageY) {
                return { x: ev.pageX, y: ev.pageY };
            }

            return {
                x: ev.clientX + document.body.scrollLeft - document.body.clientLeft,
                y: ev.clientY + document.body.scrollTop - document.body.clientTop,
            };
            // if (ev) {

            // } else {
            //     return {
            //         x: document.body.scrollLeft - document.body.clientLeft,
            //         y: document.body.scrollTop - document.body.clientTop,
            //     };
            // }
        };
        init = () => {
            // eslint-disable-next-line one-var
            const col = this.refs.col,
                l_t = this.refs.l_t,
                l_b = this.refs.l_b,
                r_t = this.refs.r_t,
                r_b = this.refs.r_b,
                ball1 = this.refs.ball1,
                ball2 = this.refs.ball2,
                ball3 = this.refs.ball3,
                ball4 = this.refs.ball4,
                chib1 = this.refs.chib1,
                chib2 = this.refs.chib2;

            col.style.width = `${realW}px`;
            col.style.height = `${realH}px`;
            const real_scale = realW / realH;
            // eslint-disable-next-line one-var
            const ltH = l_t.offsetHeight,
                ltW = l_t.offsetWidth,
                lbH = l_b.offsetHeight,
                lbW = l_b.offsetWidth,
                rtH = r_t.offsetHeight,
                rtW = r_t.offsetWidth,
                rbH = r_b.offsetHeight,
                rbW = r_b.offsetWidth,
                b1H = ball1.offsetHeight,
                b1W = ball1.offsetWidth,
                b2H = ball2.offsetHeight,
                b2W = ball2.offsetWidth,
                b3H = ball3.offsetHeight,
                b3W = ball3.offsetWidth,
                b4H = ball4.offsetHeight,
                b4W = ball4.offsetWidth,
                chib1W = chib1.offsetWidth,
                chib2W = chib2.offsetWidth;

            if (real_scale >= 1.2) {
                l_t.style.width = `${ltH * 1.85}px`;
                l_b.style.width = `${lbH * 1.64}px`;
                r_t.style.width = `${rtH}px`;
                r_b.style.width = ` ${rbH * 2.2}px`;
                ball1.style.width = `${b1H * 1.21}px`;
                ball2.style.width = `${b2H * 0.91}px`;
                ball3.style.width = `${b3H * 0.48}px`;
                ball4.style.width = `${b4H * 1.34}px`;
            }
            if (real_scale < 1.2) {
                l_t.style.height = `${ltW / 1.85}px`;
                l_b.style.height = `${lbW / 1.64}px`;
                r_t.style.height = `${rtW}px`;
                r_b.style.height = `${rbW / 2.2}px`;
                ball1.style.height = `${b1W / 1.21}px`;
                ball2.style.height = `${b2W / 0.91}px`;
                ball3.style.height = `${b3W / 0.48}px`;
                ball4.style.height = `${b4W / 1.34}px`;
            }
            chib1.style.height = `${chib1W / 1.87}px`;
            chib2.style.height = `${chib2W / 1.87}px`;
            // 彩色层蒙版初始状态
            this.refs.chib12.style.webkitMaskPosition = `${-realW * 0.34 * 0.91}px 0px`;
            this.refs.chib12.style.transition = 'all 5s';
            this.refs.chib22.style.webkitMaskPosition = `${realW * 0.34 * 0.91}px 0px`;
            this.refs.chib22.style.transition = 'all 5s';
        };
        findDimensions = () => {
            // 获取窗口宽度
            if (window.innerWidth) realW = window.innerWidth;
            else if (document.body && document.body.clientWidth) realW = document.body.clientWidth;
            // 获取窗口高度
            if (window.innerHeight) realH = window.innerHeight;
            else if (document.body && document.body.clientHeight) realH = document.body.clientHeight;
            // 通过深入Document内部对body进行检测，获取窗口大小
            if (
                document.documentElement &&
                document.documentElement.clientHeight &&
                document.documentElement.clientWidth
            ) {
                realH = document.documentElement.clientHeight; // 浏览器的高*/
                realW = document.documentElement.clientWidth; // 浏览器的宽
            }
            this.init();
        };
        handleLoad = () => {
            setTimeout(() => this.color_c(), 3000);
            setTimeout(() => this.color_b(), 1800);
            this.test();
        };
        handleToggleClick = () => {
            // 统计
            const now = new Date().getTime();

            // setpage.src='https://sapp.d.ifeng.com/stat.html?site=bncfzp&dtfrom=dhclick&dateline='+ (new Date).getTime();
            setpage.src = `https://sapp.d.ifeng.com/stat.html?site=bncfzp&dtfrom=dhclick&dateline=${now}`;
            const leftDisplay = this.state.left;

            console.log('click');

            if (leftDisplay) {
                this.setState({
                    left: false,
                });
            } else {
                this.setState({
                    left: true,
                });
            }
            this.setState({
                bef: false,
                toggleOpen: true,
                click: false,
            });
        };
        render() {
            const { content } = this.props;
            const { leftNav, rightNav } = content;

            const {
                bef,
                toggle,
                toggleOpen,
                click,
                left,
                box1pClass,
                box2pClass,
                box3pClass,
                box4pClass,
                ball1Class,
                ball2Class,
                ball3Class,
                ball4Class,
            } = this.state;

            return (
                <div>
                    <div className={styles.col} ref="col">
                        <img src="//p0.ifengimg.com/fe/fh_index/images/bg_a921d451.jpg" className={styles.bj_bg} />
                        <div className={styles.l_t} ref="l_t">
                            <a ref="box1a" />
                            <p ref="box1p" className={box1pClass ? styles.tj_title : ''} />
                        </div>
                        <div className={styles.l_b} ref="l_b">
                            <a ref="box2a" />
                            <p ref="box2p" className={box2pClass ? styles.tj_title : ''} />
                        </div>
                        <div className={styles.r_t} ref="r_t">
                            <a ref="box3a" />
                            <p ref="box3p" className={box3pClass ? styles.tj_title : ''} />
                        </div>
                        <div className={styles.r_b} ref="r_b">
                            <a ref="box4a" />
                            <p ref="box4p" className={box4pClass ? styles.tj_title : ''} />
                        </div>
                        <Chip id="110037" type="struct" title="右侧导航" groupName="凤凰招聘" content={rightNav}>
                            <Right />
                        </Chip>
                        <div
                            className={
                                ball1Class
                                    ? `${styles.ball} ${styles.dw1} ${styles.amt}`
                                    : `${styles.ball} ${styles.dw1}`
                            }
                            ref="ball1">
                            <div
                                className={
                                    ball1Class
                                        ? `${styles.dw1_downloads} ${styles.amt_downloads}`
                                        : styles.dw1_downloads
                                }>
                                <a href={rightNav[0].url}>
                                    <img src="//p0.ifengimg.com/fe/fh_index/images/shzp_a5ae1296.png" alt="" />
                                </a>
                            </div>
                            <a href={rightNav[0].url} className={styles.btn}>
                                <img src="//p0.ifengimg.com/fe/fh_index/images/bird_l_top_935ed5d7.png" alt="" />
                            </a>
                        </div>
                        <div
                            className={
                                ball2Class
                                    ? `${styles.ball} ${styles.dw2} ${styles.amt}`
                                    : `${styles.ball} ${styles.dw2}`
                            }
                            ref="ball2">
                            <div
                                className={
                                    ball2Class
                                        ? `${styles.dw2_downloads} ${styles.amt_downloads}`
                                        : styles.dw2_downloads
                                }>
                                <a href={rightNav[1].url}>
                                    <img src="//p0.ifengimg.com/fe/fh_index/images/rzfh_2c8936b3.png" alt="" />
                                </a>
                            </div>
                            <a href={rightNav[1].url} className={styles.btn}>
                                <img src="//p0.ifengimg.com/fe/fh_index/images/bird_l_bot_8ba75dbf.png" alt="" />
                            </a>
                        </div>
                        <div
                            className={
                                ball3Class
                                    ? `${styles.ball} ${styles.dw3} ${styles.amt}`
                                    : `${styles.ball} ${styles.dw3}`
                            }
                            ref="ball3">
                            <div
                                className={
                                    ball3Class
                                        ? `${styles.dw3_downloads} ${styles.amt_downloads}`
                                        : styles.dw3_downloads
                                }>
                                <a href={rightNav[2].url}>
                                    <img src="//p0.ifengimg.com/fe/fh_index/images/xyzp_e95216d9.png" alt="" />
                                </a>
                            </div>
                            <a href={rightNav[2].url} className={styles.btn}>
                                <img src="//p0.ifengimg.com/fe/fh_index/images/bird_r_top_6e47e8da.png" alt="" />
                            </a>
                        </div>
                        <div
                            className={
                                ball4Class
                                    ? `${styles.ball} ${styles.dw4} ${styles.amt}`
                                    : `${styles.ball} ${styles.dw4}`
                            }
                            ref="ball4">
                            <div
                                className={
                                    ball4Class
                                        ? `${styles.dw4_downloads} ${styles.amt_downloads}`
                                        : styles.dw4_downloads
                                }>
                                <a href={rightNav[3].url}>
                                    <img src="//p0.ifengimg.com/fe/fh_index/images/gyfh_7ee08ad0.png" alt="" />
                                </a>
                            </div>
                            <a href={rightNav[3].url} className={styles.btn}>
                                <img src="//p0.ifengimg.com/fe/fh_index/images/bird_r_bot_f057d00e.png" alt="" />
                            </a>
                        </div>
                    </div>
                    <Chip id="110036" type="struct" title="左侧导航" groupName="凤凰招聘" content={leftNav}>
                        <Left />
                    </Chip>
                    <div
                        id="nav"
                        className={
                            left
                                ? `${styles.nav} ${styles.top_right} ${styles.open}`
                                : `${styles.nav} ${styles.top_right}`
                        }>
                        <a href={leftNav[0].url} className={styles.disc1}>
                            <div>
                                {leftNav[0].title}
                                <br />
                                {leftNav[0].subtitle}
                            </div>
                        </a>
                        <a href={leftNav[1].url} className={styles.disc2}>
                            <div>
                                {leftNav[1].title}
                                <br />
                                {leftNav[1].subtitle}
                            </div>
                        </a>
                        <a href={leftNav[2].url} className={styles.disc3}>
                            <div>
                                {leftNav[2].title}
                                <br />
                                {leftNav[2].subtitle}
                            </div>
                        </a>
                        <a href={leftNav[3].url} className={styles.disc4}>
                            <div>
                                {leftNav[3].title}
                                <br />
                                {leftNav[3].subtitle}
                            </div>
                        </a>
                        <div className={bef ? styles.bef : ''} ref="bef" />
                        <a
                            className={`${styles.disc} ${styles.begin} ${styles.toggle}`}
                            onClick={this.handleToggleClick}>
                            {left ? (
                                <img src="//p0.ifengimg.com/fe/fh_index/images/closed_88a882d3.png" alt="" />
                            ) : (
                                <img src="//p0.ifengimg.com/fe/fh_index/images/zk_56dab43e.png" alt="" />
                            )}
                            {/* <img src="//p0.ifengimg.com/fe/fh_index/images/zk_56dab43e.png" alt="" /> */}
                        </a>
                        <a className={styles.f_logo_l0}>
                            <img src="//p0.ifengimg.com/fe/fh_index/images/l_logo_34403519.png" />
                        </a>
                    </div>
                    <div className={styles.chib1} ref="chib1">
                        <div ref="chib11">
                            <img src="//p0.ifengimg.com/fe/fh_index/images/f1_cc6a5046.png" alt="" />
                        </div>
                        <div ref="chib12">
                            <img src="//p0.ifengimg.com/fe/fh_index/images/f2_af729a2f.png" alt="" />
                        </div>
                    </div>
                    <div className={styles.chib2} ref="chib2">
                        <div ref="chib21" />
                        <div ref="chib22" />
                    </div>
                    <img src="//p0.ifengimg.com/fe/fh_index/images/fh_logo_2664407a.png" className={styles.fh_logo} />
                    <ChipEdit />
                </div>
            );
        }
    },
);

export { Layout };
export default Layout;
